import { createFileRoute } from "@tanstack/react-router";
import {
  SpringsLandingPage,
  buildSpringsLandingHead,
} from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-plumber-seo");

export const Route = createFileRoute("/colorado-springs-plumber-seo")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
